module.exports = __webpack_public_path__ + "img/qrcode.9b6e4bc4.png";